import { Component, OnInit } from '@angular/core';
import { NotificationsService } from '../../services/notifications.service';
import { PortalSettingsService } from '../../services/portal-settings.service';

@Component({
  selector: 'app-notification-page',
  templateUrl: './notification-page.component.html',
  styleUrls: ['./notification-page.component.css']
})
export class NotificationPageComponent implements OnInit {
  notifications: any[] = [];
  portalSettings: any;
  dateFormat: string = "";

  constructor(private notificationsService: NotificationsService, private portalSettingsService: PortalSettingsService)
  {
    this.portalSettings = portalSettingsService.getPortalSettings();
  }

  ngOnInit() {
    this.notifications = this.notificationsService.getNotifications();
    this.dateFormat = this.portalSettings.CountryDateCode.ConfigValue == 'US' ? 'MM/dd/yyyy hh:mm a' : 'dd/MM/yyyy hh:mm a';
  }
}
